<template>
    <div>
        <c-search-box ref="searchbox" :isShowSearch="false" @enter="getList">
            <template slot="search">
                <div class="col-6">
                    <c-plant
                        type="search"
                        name="plantCd"
                        v-model="searchParam.plantCd"
                        @datachange="getList"
                    />
                </div>
                <div class="col-6">
                    <c-dept
                        type="search"
                        name="deptCd"
                        label="관리부서"
                        v-model="searchParam.deptCd"
                        @input="getList"
                    />
                </div>
            </template>
        </c-search-box>
        <c-table
            ref="processTable"
            :merge="grid.merge"
            :columns="grid.columns"
            :data="grid.data"
            :gridHeight="grid.height"
            :selection="popupParam.type"
            :filtering="true"
            :columnSetting="false"
            :isFullScreen="false"
            :isTitle="false"
            :rowKey="rowKey"
        >
        </c-table>
        <div class="space-bottom-button"></div>
        <!-- 버튼 영역 -->
        <div class="search-box-btn">
            <q-btn-group outline>
                <c-btn
                    label="선택"
                    icon="check"
                    color="teal-5"
                    @btnClicked="select"
                />
            </q-btn-group>
        </div>
    </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
    name: "process-pop",
    props: {
        popupParam: {
            type: Object,
            default: () => ({
                type: "multiple",
                processLevelCd: "20",
            }),
        },
        contentHeight: {
            type: [String, Number],
            default: function () {
                return "auto";
            },
        },
    },
    data() {
        return {
            rowKey: "processCd",
            listUrl: "",
            grid: {
                merge: [
                    { index: 0, colName: "deptCd" },
                    { index: 1, colName: "lineCd" },
                ],
                columns: [
                    {
                        name: "deptName",
                        field: "deptName",
                        label: "관리부서",
                        align: "center",
                        sortable: true,
                    },
                    {
                        name: "lineName",
                        field: "lineName",
                        label: "라인",
                        align: "center",
                        sortable: true,
                    },
                    {
                        name: "processName",
                        field: "processName",
                        label: "공정",
                        align: "center",
                        sortable: true,
                    },
                ],
                data: [],
                height: "400px",
            },
            searchParam: {
                plantCd: null,
                processName: "",
                processLevelCd: "20",
                deptCd: null,
            },
            editable: true,
            searchUrl: "",
        };
    },
    beforeCreate() {},
    created() {},
    beforeMount() {
        Object.assign(this.$data, this.$options.data());
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {},
    watch: {
        contentHeight() {
            let height =
                this.contentHeight -
                this.$refs["searchbox"].$el.offsetHeight -
                50;
            if (height < 400) {
                height = 500;
            }
            this.grid.height = height + "px";
        },
    },
    methods: {
        init() {
            this.listUrl = selectConfig.mdm.process.list.url;
            this.getList();
        },
        getList() {
            this.$http.url = this.listUrl;
            this.$http.type = "GET";
            this.searchParam.processLevelCd = this.popupParam.processLevelCd
                ? this.popupParam.processLevelCd
                : "20";
            this.$http.param = this.searchParam;
            this.$http.request((_result) => {
                this.grid.data = _result.data;
            });
        },
        select() {
            let selectData = this.$refs["processTable"].selected;
            if (!selectData || selectData.length === 0) {
                window.getApp.$emit("ALERT", {
                    title: "안내", // 안내
                    message: "공정을 선택하세요.", // 공정을 선택하세요.
                    type: "warning", // success / info / warning / error
                });
            } else {
                this.$emit("closePopup", selectData);
            }
        },
    },
};
</script>
